(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1774],{

/***/ 51774:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Content040": function() { return /* binding */ Content040; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var shared_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87900);
/* harmony import */ var _Content040_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(61477);
/* harmony import */ var _Content040_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_Content040_module_scss__WEBPACK_IMPORTED_MODULE_3__);




var Content040 = function(param) {
    var payload = param.payload;
    var ref;
    var title = (ref = payload === null || payload === void 0 ? void 0 : payload.title) !== null && ref !== void 0 ? ref : "";
    var ref1;
    var template = (ref1 = payload === null || payload === void 0 ? void 0 : payload.template) !== null && ref1 !== void 0 ? ref1 : "light";
    var ref2;
    var list = (ref2 = payload === null || payload === void 0 ? void 0 : payload.list) !== null && ref2 !== void 0 ? ref2 : [];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_Content040_module_scss__WEBPACK_IMPORTED_MODULE_3___default().wrapper), (_Content040_module_scss__WEBPACK_IMPORTED_MODULE_3___default())[template]),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_2__/* .Container */ .W2, {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (_Content040_module_scss__WEBPACK_IMPORTED_MODULE_3___default().block),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_2__/* .Heading4 */ .k8, {
                        className: (_Content040_module_scss__WEBPACK_IMPORTED_MODULE_3___default().title),
                        color: "dark",
                        children: title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: (_Content040_module_scss__WEBPACK_IMPORTED_MODULE_3___default().content),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_2__/* .OrderedList */ .GS, {
                            items: list,
                            appearance: "bold",
                            className: (_Content040_module_scss__WEBPACK_IMPORTED_MODULE_3___default().list)
                        })
                    })
                ]
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (Content040);


/***/ }),

/***/ 61477:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Content040_wrapper___aNiG","title":"Content040_title__yQCvT","light":"Content040_light__Dn6ya","dark":"Content040_dark___QOUg","content":"Content040_content__1WtcQ","list":"Content040_list__uaVWi"};

/***/ })

}]);